export class Parceiro {
    
    cdParceiro: number;
    nmParceiro: string;
    
    constructor() {

    }
}


// WEBPACK FOOTER //
// /home/runner/_work/fini-sta-01-estatico-sitecliente/fini-sta-01-estatico-sitecliente/src/app/modelo/parceiro.ts